import * as React from 'react';

import Typography from 'shared/newComponents/Typography';
import {
  TypographyColor,
  TypographySize,
  TypographyType,
  TypographyWeight
} from 'shared/newEntities/components/Typography';
import TypedTransComponent from 'shared/components/TypedTransComponent';
import ExternalLink from 'shared/newComponents/ExternalLink';

import { InstructionSlotProps } from '../../FormWithToken';

import './MaxInstruction.modules.scss';

const MaxInstruction: React.FC<InstructionSlotProps> = ({ url }) => {
  return (
    <div styleName="instruction">
      <Typography
        styleName="instruction__title"
        fontType={TypographyType.text}
        fontSize={TypographySize.m}
        fontWeight={TypographyWeight.heavy}
      >
        <TypedTransComponent
          ns="newContainers"
          i18nKey="ChannelsModal.ChannelForm.Max.title"
        >
          Доступен только для юрлиц.
        </TypedTransComponent>
      </Typography>
      <Typography fontType={TypographyType.text} fontSize={TypographySize.s}>
        <TypedTransComponent
          ns="newContainers"
          i18nKey="ChannelsModal.ChannelForm.Max.firstParagraph"
        >
          1. Перейдите по{'&nbsp;'}
          <ExternalLink
            fontType={TypographyType.text}
            fontSize={TypographySize.s}
            fontColor={TypographyColor.link}
            underline
            href={url}
          >
            {'ссылке'}
          </ExternalLink>
          и зарегистрируйте ЛК.
        </TypedTransComponent>
      </Typography>
      <Typography fontType={TypographyType.text} fontSize={TypographySize.s}>
        <TypedTransComponent
          ns="newContainers"
          i18nKey="ChannelsModal.ChannelForm.Max.secondParagraph"
        >
          2. Пройдите верификацию вашей организации.
        </TypedTransComponent>
        <TypedTransComponent
          ns="newContainers"
          i18nKey="ChannelsModal.ChannelForm.Max.thirdParagraph"
        >
          3. Создайте чат-бота и отправьте его на модерацию.
        </TypedTransComponent>
      </Typography>
      <Typography fontType={TypographyType.text} fontSize={TypographySize.s}>
        <TypedTransComponent
          ns="newContainers"
          i18nKey="ChannelsModal.ChannelForm.Max.fourthParagraph"
        >
          4. После подтверждения получите токен и вставьте его в поле ниже.
        </TypedTransComponent>
      </Typography>
    </div>
  );
};

export default React.memo(MaxInstruction);
